import React, { useContext, useState, createContext } from "react"
import Header from "../../layouts/Header"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Checkbox, Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Button } from "@mui/material"
import BackIcon from "../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import { GlobalContext } from "../../contexts/GlobalContext"
import { showWarning } from "../../api"
import Swal from "sweetalert2"
import getIconComponent from "../utils/getIconComponent"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../utils/reactTableActions/exportToolbarActions"

import CustomDatePicker from "../../components/CustomDatePicker"
import dayjs from "dayjs"
import fetchwrapper from "../../services/interceptors/fetchwrapper"

// Íconos
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import SearchIcon from "@mui/icons-material/Search"

// 1. CREAMOS UN CONTEXTO LOCAL PARA ROMPER LA MEMOIZACIÓN DE LA TABLA
const SelectionContext = createContext()

const StyledRootStyles = {
  display: "flex",
  flexDirection: "column",
  marginTop: "64px",
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const AsignaciondeCartera = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  const [selectedCuotas, setSelectedCuotas] = useState([])

  // Controladores de estado visual para filtros transaccionales
  const [expanded, setExpanded] = useState(false)
  const [refreshTableKey, setRefreshTableKey] = useState(0)

  // Estado centralizado de filtros principales
  const [filtros, setFiltros] = useState({
    fecEmiDesde: null,
    fecEmiHasta: null,
    fecVenDesde: null,
    fecVenHasta: null,
  })

  const handleInputChange = (field, value) => {
    setFiltros((prev) => ({ ...prev, [field]: value }))
  }

  const handleFiltrar = () => {
    setRefreshTableKey((prev) => prev + 1)
    setExpanded(false)
    setSelectedCuotas([]) // Limpiamos la selección anterior al hacer una nueva búsqueda
  }

  const handleToggleRow = (row) => {
    const safeSelectedCuotas = Array.isArray(selectedCuotas) ? selectedCuotas : []
    const isSelected = safeSelectedCuotas.some(
      (c) =>
        String(c.facnumfac).trim() === String(row.facnumfac).trim() &&
        String(c.facsecuen).trim() === String(row.facsecuen).trim(),
    )
    if (isSelected) {
      setSelectedCuotas((prev) =>
        prev.filter(
          (c) =>
            !(
              String(c.facnumfac).trim() === String(row.facnumfac).trim() &&
              String(c.facsecuen).trim() === String(row.facsecuen).trim()
            ),
        ),
      )
    } else {
      setSelectedCuotas((prev) => [...prev, row])
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 20px 30px",
            fontSize: "25px",
            textAlign: "center",
          }}
        >
          <b>Asignación y Distribución de Cartera</b>
        </div>

        <Box sx={StyledRootStyles}>
          {/* ACORDEÓN DE FILTROS TRANSACCIONALES */}
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{ mb: 3, borderRadius: 2, boxShadow: 3, "&:before": { display: "none" } }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "#f5f7fa", borderRadius: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" color="primary">
                Parámetros de Búsqueda
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomDatePicker
                    label="Emisión Desde"
                    value={filtros.fecEmiDesde}
                    setValue={(v) => handleInputChange("fecEmiDesde", v)}
                    isOptional={true}
                    format="DD/MM/YYYY"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomDatePicker
                    label="Emisión Hasta"
                    value={filtros.fecEmiHasta}
                    setValue={(v) => handleInputChange("fecEmiHasta", v)}
                    isOptional={true}
                    format="DD/MM/YYYY"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomDatePicker
                    label="Vencimiento Desde"
                    value={filtros.fecVenDesde}
                    setValue={(v) => handleInputChange("fecVenDesde", v)}
                    isOptional={true}
                    format="DD/MM/YYYY"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomDatePicker
                    label="Vencimiento Hasta"
                    value={filtros.fecVenHasta}
                    setValue={(v) => handleInputChange("fecVenHasta", v)}
                    isOptional={true}
                    format="DD/MM/YYYY"
                  />
                </Grid>

                {/* Botón de Acción */}
                <Grid item xs={12} display="flex" justifyContent="flex-end" mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<SearchIcon />}
                    onClick={handleFiltrar}
                    sx={{ px: 4, fontWeight: "bold" }}
                  >
                    Ejecutar Búsqueda
                  </Button>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          {/* 2. ENVOLVEMOS LA TABLA EN EL CONTEXTO PROVEYENDO EL ESTADO ACTUAL */}
          <SelectionContext.Provider value={{ selectedCuotas, handleToggleRow }}>
            <CustomConditionalActionsTableServer
              key={refreshTableKey}
              endpoint={refreshTableKey === 0 ? "" : "/AsignaciondeCartera/getAllCarteraDisponible"}
              endpointJson={{
                filters: {},
                externalFilters: {
                  fecEmiDesde: filtros.fecEmiDesde ? dayjs(filtros.fecEmiDesde).format("YYYY-MM-DD") : "",
                  fecEmiHasta: filtros.fecEmiHasta ? dayjs(filtros.fecEmiHasta).format("YYYY-MM-DD") : "",
                  fecVenDesde: filtros.fecVenDesde ? dayjs(filtros.fecVenDesde).format("YYYY-MM-DD") : "",
                  fecVenHasta: filtros.fecVenHasta ? dayjs(filtros.fecVenHasta).format("YYYY-MM-DD") : "",
                },
              }}
              errorMsgFilterSearch="Error al cargar el listado de cartera"
              queryKeyModal={`Cartera_Completa`}
              perPage={10}
              rowActionsWidthTable={120}
              rowActions={(row) => {
                const asignarAction = selectedMenuInfo?.data?.barraAcciones?.find(
                  (a) => a.acccaption === "ASIGNAR" || a.acccaption === "EDITAR" || a.acccaption === "CREAR",
                )
                const actions = []
                if (asignarAction) {
                  actions.push({
                    label: "Asignar Individual",
                    key: "asignar",
                    icon: getIconComponent(asignarAction.accnameicono, asignarAction.acctipoico),
                    onClick: (row) => navigate("asignar", { state: { cuotasSeleccionadas: [row.original] } }),
                  })
                }
                return actions
              }}
              topToolbarCustomActions={({ table, device }) => {
                const acciones = selectedMenuInfo?.data?.barraAcciones || []
                const toolbarActions = []

                const marcarAction = acciones.find((a) => a.acccaption === "MARCARTODOS")
                if (marcarAction) {
                  toolbarActions.push({
                    label: "Seleccionar Todos",
                    key: "marcarTodosBtn",
                    icon: getIconComponent(marcarAction.accnameicono, marcarAction.acctipoico),
                    onClick: async () => {
                      try {
                        Swal.fire({
                          title: "Seleccionando...",
                          text: "Obteniendo la totalidad de los registros...",
                          allowOutsideClick: false,
                          didOpen: () => Swal.showLoading(),
                        })

                        const rawFilters = table.getState().columnFilters || []
                        const dictFilters = {}
                        rawFilters.forEach((f) => {
                          dictFilters[f.id] = f.value
                        })

                        const payload = {
                          page: 1,
                          perPage: 100000, // Número grande y seguro para SQL
                          filters: dictFilters,
                          externalFilters: {
                            fecEmiDesde: filtros.fecEmiDesde ? dayjs(filtros.fecEmiDesde).format("YYYY-MM-DD") : "",
                            fecEmiHasta: filtros.fecEmiHasta ? dayjs(filtros.fecEmiHasta).format("YYYY-MM-DD") : "",
                            fecVenDesde: filtros.fecVenDesde ? dayjs(filtros.fecVenDesde).format("YYYY-MM-DD") : "",
                            fecVenHasta: filtros.fecVenHasta ? dayjs(filtros.fecVenHasta).format("YYYY-MM-DD") : "",
                          },
                        }

                        // USO DE fetchwrapper para garantizar total compatibilidad con el backend
                        const response = await fetchwrapper("/AsignaciondeCartera/getAllCarteraDisponible", {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(payload),
                        })

                        const result = await response.json()
                        const allRows = result.data || []

                        if (allRows.length > 0) {
                          setSelectedCuotas(allRows)
                          Swal.fire({
                            title: "Selección Exitosa",
                            text: `Se marcaron ${allRows.length} registros para asignación.`,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                          })
                        } else {
                          Swal.fire({
                            title: "Aviso",
                            text: "La consulta no devolvió registros.",
                            icon: "info",
                            timer: 2000,
                            showConfirmButton: false,
                          })
                        }
                      } catch (error) {
                        console.error(error)
                        Swal.fire("Error", "No se pudo completar la selección masiva.", "error")
                      }
                    },
                  })
                }

                // El botón de quitar selección ya aplicará para todos porque vacía el estado centralizado
                const desmarcarAction = acciones.find((a) => a.acccaption === "DESMARCARTODOS")
                if (desmarcarAction) {
                  toolbarActions.push({
                    label: "Quitar Selección",
                    key: "desmarcarTodosBtn",
                    icon: getIconComponent(desmarcarAction.accnameicono, desmarcarAction.acctipoico),
                    onClick: () => {
                      setSelectedCuotas([])
                      Swal.fire({
                        title: "Selección Limpiada",
                        text: "Se desmarcaron todos los registros.",
                        icon: "info",
                        timer: 1500,
                        showConfirmButton: false,
                      })
                    },
                  })
                }

                const asignarAction = acciones.find(
                  (a) => a.acccaption === "ASIGNAR" || a.acccaption === "CREAR" || a.acccaption === "EJECUTAR",
                )
                if (asignarAction) {
                  toolbarActions.push({
                    label: `Asignación Masiva (${(Array.isArray(selectedCuotas) ? selectedCuotas : []).length})`,
                    key: "asignacionMasivaBtn",
                    icon: getIconComponent(asignarAction.accnameicono, asignarAction.acctipoico),
                    onClick: () => {
                      const safeSelectedCuotas = Array.isArray(selectedCuotas) ? selectedCuotas : []
                      if (safeSelectedCuotas.length === 0) {
                        showWarning("Seleccione al menos una cuota marcando las casillas de la tabla.")
                        return
                      }
                      navigate("asignar", { state: { cuotasSeleccionadas: safeSelectedCuotas } })
                    },
                  })
                }

                const exportarAction = acciones.find((a) => a.acccaption === "EXPORTAR")
                if (exportarAction) {
                  toolbarActions.push({
                    type: "dropdown",
                    label: exportarAction.acccaption,
                    key: "exportDropdown",
                    icon: getIconComponent(exportarAction.accnameicono, exportarAction.acctipoico),
                    actions: [
                      {
                        label: "Exportar PDF",
                        key: "pdf",
                        onClick: ({ columns, data }) => {
                          const title = `Reporte de Cartera`
                          device === "sm"
                            ? handleExportDataPdfSMScreen(columns, data, title, title)
                            : handleExportDataPdfLGScreen(columns, table.getCoreRowModel().rows, title, title)
                        },
                      },
                      {
                        label: "Exportar CSV",
                        key: "csv",
                        onClick: ({ data }) => handleAllExportDataCSV(data, `Cartera_SIAC`),
                      },
                    ],
                  })
                }

                return toolbarActions
              }}
              columnsTable={[
                {
                  accessorKey: "seleccion",
                  header: "Sel.",
                  size: 60,
                  enableColumnFilter: false,
                  Cell: ({ row }) => {
                    const { selectedCuotas, handleToggleRow } = useContext(SelectionContext)
                    const safeSelectedCuotas = Array.isArray(selectedCuotas) ? selectedCuotas : []

                    const isSelected = safeSelectedCuotas.some(
                      (c) =>
                        String(c.facnumfac).trim() === String(row.original.facnumfac).trim() &&
                        String(c.facsecuen).trim() === String(row.original.facsecuen).trim(),
                    )

                    return (
                      <Checkbox
                        checked={isSelected}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => handleToggleRow(row.original)}
                      />
                    )
                  },
                },
                {
                  accessorKey: "estado_asignacion",
                  header: "Estado",
                  size: 130,
                  Cell: ({ cell }) => {
                    const val = cell.getValue()
                    return (
                      <span style={{ fontWeight: "bold", color: val === "SIN ASIGNAR" ? "#b71c1c" : "#196C87" }}>
                        {val}
                      </span>
                    )
                  },
                },
                { accessorKey: "facnumfac", header: "Factura", size: 160 },
                { accessorKey: "facsecuen", header: "Cuota", size: 80 },
                { accessorKey: "clicodigo", header: "Cód. Cliente", size: 100 },
                { accessorKey: "clinombre", header: "Cliente", size: 250 },
                { accessorKey: "garcodigo", header: "Cód. Garante", size: 100 },
                { accessorKey: "garnombre", header: "Garante", size: 250 },
                {
                  accessorKey: "condicion_vencimiento",
                  header: "Condición",
                  size: 130,
                  Cell: ({ cell }) => {
                    const val = cell.getValue()
                    return (
                      <span style={{ fontWeight: "bold", color: val === "VENCIDA" ? "#b71c1c" : "#2E7D32" }}>
                        {val}
                      </span>
                    )
                  },
                },
                { accessorKey: "facfecemi", header: "F. Emision Ini", size: 120 },
                { accessorKey: "facfecven", header: "F. Vencimiento", size: 120 },
                {
                  accessorKey: "factotal",
                  header: "Total",
                  size: 100,
                  Cell: ({ cell }) => <span>${Number(cell.getValue() || 0).toFixed(2)}</span>,
                },
                {
                  accessorKey: "facsaldo",
                  header: "Saldo a Cobrar",
                  size: 130,
                  Cell: ({ cell }) => (
                    <span style={{ fontWeight: "bold", color: "#b71c1c" }}>
                      ${Number(cell.getValue() || 0).toFixed(2)}
                    </span>
                  ),
                },
                {
                  accessorKey: "usrrecaudador",
                  header: "Recaudador Asignado",
                  size: 160,
                  Cell: ({ cell }) => {
                    const val = cell.getValue()
                    return val ? (
                      <span style={{ color: "#196C87", fontWeight: "bold" }}>{val}</span>
                    ) : (
                      <span style={{ color: "#9e9e9e", fontStyle: "italic" }}>-</span>
                    )
                  },
                },
              ]}
            />
          </SelectionContext.Provider>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AsignaciondeCartera
